<ng-container *transloco="let t">
  <div class="admin-card">
    <app-competitor-table [languages]="languages" [filteringEnabled]="true" [event]="event"
                          [raceSettingsList]="raceSettingsList" [countries]="countries"
                          [applicationFormSettingsList]="applicationFormSettingsList" [genders]="genders"
                          [showEmptyState]="true" [showHeader]="false" [competitors]="competitors" [measurements]="measurements"
                          [tableMode]="CompetitorTableType.EVENT_VIEW" [raceFilteringEnabled]="true"
                          [isAdmin]="true" [showLoadMoreButton]="true" (filterChange)="onFilterChange($event)"
                          (chronometarRaceCompetitorStartStop)="onChronometarRaceCompetitorStartStop($event)">
      <div slot="competitorTableAdminTrailingWidgets">
        <app-admin-actions-header (onExportToPdf)="onGetFileFromServer('pdf')"
                                  (onExportToXls)="onGetFileFromServer('xlsx')">
          <div slot="leadingWidgets">
          </div>
          <div slot="trailingWidgets">
            <div class="d-flex flex-column flex-md-row">
              <div class="pe-0 pe-md-3 pb-3 pb-md-0">
                <app-rounded-button [label]="t('race.management.printStartList')" (onClick)="onPrintStartList()"
                                    [isDisabled]="competitors.length === 0"><i class="bi bi-plus-circle pe-2"></i>
                </app-rounded-button>
              </div>
              <div class="pe-2">
                <app-rounded-button [label]="t('race.management.competitors.assign.chip.numbers')"
                                    [btnClass]="'rounded-button--button-black-solid'"
                                    (onClick)="assignChipNumber()">
                  <i class="bi bi-list-ol pe-2"></i>
                </app-rounded-button>
              </div>
              @if (!measurements) {
                <div class="pe-0 pe-md-3 pe-3">
                  <app-rounded-button [label]="t('race.management.competitors.register')" (onClick)="onRegisterToRace()"
                                      [isDisabled]="disableRegisterToRace"><i class="bi bi-plus-circle pe-2"></i>
                  </app-rounded-button>
                </div>
              }
            </div>
          </div>
        </app-admin-actions-header>
      </div>
    </app-competitor-table>
  </div>
</ng-container>
